import { Table, Typography } from 'antd';
import { priorityWithIcon } from '../../helper';
import DueDateBadge from '../DueDateBadge';
import UserGroup from '../UserGroup';

const TaskTable = ({ data, isSite = true, tableHeight = 330 }) => {
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text) => (
        <Typography.Text strong title={text} ellipsis={{ tooltip: true }} style={{ maxWidth: 200 }}>
          {text}
        </Typography.Text>
      ),
    },
    {
      title: 'Site',
      dataIndex: 'restaurant_title',
      key: 'restaurant_title',
      hidden: !isSite,
      render: (text) => (
        <Typography.Text ellipsis={{ tooltip: true }} style={{ maxWidth: 100 }}>
          {text}
        </Typography.Text>
      ),
    },
    {
      title: 'Assignee',
      dataIndex: 'assignees',
      key: 'assignees',
      width: 120,
      render: (assignees) => <UserGroup users={assignees} maxCount={2} />,
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      render: (priority) => {
        return priorityWithIcon(priority);
      },
    },
    {
      title: 'Due Date',
      dataIndex: 'due_date',
      key: 'due_date',
      width: 220,
      render: (date) => <DueDateBadge date={date} />
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="id"
      components={{
        header: {
          cell: (props) => (
            <th
              {...props}
              style={{
                ...props.style,
                background: 'transparent',
              }}
            />
          ),
        },
        body: {
          cell: (props) => (
            <td
              {...props}
              style={{
                ...props.style,
                padding: '6px 16px',
              }}
            />
          ),
        },
      }}
      style={{
        background: 'rgba(255, 255, 255, 0.9)',
      }}
      scroll={{ x: 'max-content', y: !!data?.length ? tableHeight : null }}
    />
  );
};

export default TaskTable;
